// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--Yj7NI","iconItem":"iconItem--1yTd4"};